import {Injectable,  ViewContainerRef} from "@angular/core";
import {DialogOptsModel} from "./models/dialog-opts.model";
import {DialogComponent} from "./dialog.component";
import {firstValueFrom, take} from "rxjs";
import {LanguageService} from "../../services/language.service";

@Injectable({providedIn: 'root'})
export class DialogService {
  private viewContainer: ViewContainerRef;

  constructor(private translationService: LanguageService) {
  }

  setViewContainer(viewContainer: ViewContainerRef) {
    this.viewContainer = viewContainer;
  }

  async prompt(opts: DialogOptsModel): Promise<boolean> {
    const ref = this.viewContainer.createComponent(DialogComponent);
    ref.instance.title = opts.title;
    ref.instance.content = opts.message;

    return firstValueFrom(ref.instance.onResult.pipe(take(1))).then(rsp => {
      ref.destroy();
      return rsp;
    });
  }

  async confirmDelete() {
    const title = await this.translationService.translate('modal.confirmDelete');
    const message = await this.translationService.translate('modal.confirmDeleteMessage');
    return await this.prompt({
      title: title,
      message: message
    });
  }
}
